import {
	badgeCheckoutResponseSchema,
	badgePricingSchema,
	badgeStatusResponseSchema,
	clubBadgeSchema,
	type Evidence,
} from "../../schemas/finance";
import { fetchApi } from "../client/internal";

export const badges = {
	getPricing: (clubId: string) => fetchApi(`/${clubId}/badges/pricing`, badgePricingSchema),

	getStatus: (clubId: string) => fetchApi(`/${clubId}/badges`, badgeStatusResponseSchema),

	apply: (clubId: string, data: { tier: "blue" | "gold"; evidence: Evidence }) =>
		fetchApi(`/${clubId}/badges`, clubBadgeSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),

	createCheckout: (clubId: string) =>
		fetchApi(`/${clubId}/badges/checkout`, badgeCheckoutResponseSchema, {
			method: "POST",
		}),
};
